import { render } from "./index.vue?vue&type=template&id=48d4201f&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=48d4201f&scoped=true&lang=css"
import "./index.vue?vue&type=style&index=1&id=48d4201f&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48d4201f"]])

export default __exports__